<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">Добавить транзакцию</h1>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'apartment-client-details', params: { client_id: $route.params.client_id } }">← Назад к Транзакциям</router-link>
    </div>

    <transaction-add-form :client="+$route.params.client_id" @after="handleAfter" />

  </div>
</template>

<script>
import transactionAddForm from '@/components/forms/transaction/TransactionAddForm'

export default {
  name: 'apartment-client-transaction-add',
  components: { transactionAddForm },
  methods: {
    handleAfter (success) {
      if (success) {
        this.$router.push({ name: 'apartment-client-details', params: { client_id: this.$route.params.client_id } })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// ApartmentClientTransactionAdd.vue?1200f5f0